export const txtGenerator = (txt: string, fileName?: string) => {
  const blob = new Blob([txt], { type: 'text/txt;charset=utf-8;' });
  const url = window.URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.target = '_blank';
  a.download = fileName || 'report.txt';
  a.click();
};
